import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { KmsEnum } from 'src/app/areas/kms/serves/kms-enum';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';

@Component({
  selector: 'app-attr-addorupdate',
  templateUrl: './attr-addorupdate.component.html',
  styleUrls: ['./attr-addorupdate.component.css']
})
export class AttrAddorupdateComponent implements OnInit {
  //接收父组件的数据  
  @Input() addOrUpdate:string;              // 操作类型
  @Input() id:string;              // 属性主键id（自增长id）
  @Input() selectConcept:any;              // 所属概念
  @Input() modelVerId:string;              // 模型版本id
  onlyEditName:boolean = true;
  // 新增或编辑操作成功后向父组件发射数据
  @Output('attrSave') attrSave = new EventEmitter<any>();  
  // 取消操作成功后向父组件发射数据
  @Output('attrCancel') attrCancel = new EventEmitter<any>();  

  models:any = {}; // 表单信息
  // 字段类型数据组
  typeDatas = [];
  // 字段类型字典类型字段
  dictionaryField: any = KmsEnum.KGS_FILEID_TYPE_OPTION;
  formControlTypes = KmsEnum.FORM_CONTROL_TYPES;

  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
    private dicService: DictionaryService,
    private swMaskService: SwMaskService
  ) { }

  ngOnInit() {
    this.typeDatas = [];
    let typeArr = this.dicService.getDictionaryValueOrName(this.dictionaryField);
    typeArr.forEach(item => {
        if(item.text!='图片' && item.text!='三维数据'){
            this.typeDatas.push(item)
        }
    });
  }

  ngOnChanges() {
    if(this.addOrUpdate == 'editAttr'){
      this.kmsService.getOntologyById(this.id).subscribe(result => {
        if (result.code == 200) {
            let datas = result.data;
            if (datas.dictionryCode == 'Tab') {
                datas.isTab = true;
            }else {
                datas.isTab = false;
            }
            this.models = datas;
            this.models['conceptName'] = this.selectConcept.conceptName;
            this.models['conceptCode'] = this.selectConcept.conceptCode;
        }
      })
    }else{
      this.models = {
        attributeLevel: 2,
        isTab: false,
        conceptId: this.selectConcept.conceptId,
        parentId: this.selectConcept.conceptId,
        conceptCode: this.selectConcept.conceptCode,
        conceptName: this.selectConcept.conceptName,
        isRequired: false,
        isShow: true,
        modelVerId: this.modelVerId
      };
    }
  }

  // 字段类型下拉点击事件
  handleChangeClick(event) {
    // 切换至非下拉框 、 非单选按钮类型时，清空字典项的值 
    if(this.models.fieldType != this.formControlTypes.dropBox && this.models.fieldType != this.formControlTypes.treeSelect && this.models.fieldType != this.formControlTypes.radio){
        this.models.dictionryCode = '';
    }
    switch(this.models.fieldType){
        case this.formControlTypes.input: this.models.fieldLength = 200; break;
        case this.formControlTypes.textarea: this.models.fieldLength = 500; break;
        case this.formControlTypes.richTextBox: this.models.fieldLength = 1000; break;
    }
  } 

  // 表单提交方法
  onSubmit() {
    this.swMaskService.openMask("数据正在保存,请稍等...");
    // 判断是否为重命名操作
    if(this.addOrUpdate == 'editAttr' && this.onlyEditName){
      let params = {
        id:this.models.id,
        attributeName: this.models.attributeName,
      }
      this.kmsService.updateAttributeName(params).subscribe(
          result => {
              this.swMaskService.closeMask();
              if (result.code == 200) {
                this.message.success('操作成功！');
                // 当前为重命名操作才发射true,父元素接收到后将不会刷新模型树，只更新模型可视化组件
                this.attrSave.emit(true);
              } else {
                this.message.waring(result.msg);
              }
          }
      )
    }
    // 新增、编辑属性操作
    else{
      let params = JSON.parse(JSON.stringify(this.models));
      if(params.isTab){
        params.dictionryCode = 'Tab';
        params.attributeLevel = 1;
      }else{
        params.attributeLevel = 2;
        params.dictionryCode = params.dictionryCode == 'Tab' ? '' : params.dictionryCode;
      }
      this.kmsService.saveSingleOntologyUpdate(params).subscribe(
        result => {
          this.swMaskService.closeMask();
          if (result.code == 200) {
            this.message.success('操作成功！');
            this.attrSave.emit(false);
          } else {
            this.message.waring(result.msg);
          }
        }
      )
    }
  }

  // 取消新增或编辑操作
  cancel(){
    this.attrCancel.emit(true);
  }
}
